import { createContext, useContext } from 'react'

import { WidgetTourConfig } from '../models'

interface IStartWidgetToursOptions {
  includeSeen?: boolean
}

export interface IWidgetTourContext {
  activeTour: WidgetTourConfig | null
  registerTour: (tour: WidgetTourConfig) => void
  unregisterTour: (tourId: string) => void
  startTours: (tourIds: string[], options?: IStartWidgetToursOptions) => string[]
}

export const WidgetTourContext = createContext<IWidgetTourContext | null>(null)

export const useWidgetTourContext = (): IWidgetTourContext => {
  const context = useContext(WidgetTourContext)

  if (!context) {
    throw new Error('Widget Tour hooks must be used inside WidgetTourProvider')
  }

  return context
}
